import React from "react";

export default class LocationsTableHeader extends React.PureComponent {
  render() {
    const columns = [
      "Shliach",
      "Shlucha",
      "Chabad House",
      "Campus",
      "Member Since",
      "",
    ];

    return (
      <div className="rsvp-locations-table-header">
        {columns.map((column, index) => (
          <p className="flex flex-align-center" key={index}>
            {column}
          </p>
        ))}
      </div>
    );
  }
}
